///operator/audio/universal-pre-recorded

import apiCall from "../../axios";

const universalPreRecordedAudio = async (payload: any) => {
  return new Promise(async (resolve, reject) => {
  try {
    const res = await apiCall("POST", `operator/audio/universal-pre-recorded`, payload);
    resolve(res.data);
  } catch (error: any) {
    if (error.response?.data?.message) {
      reject(new Error(error.response.data.message));
    }
    reject(new Error("A network error occurred. Please try again."));
    }
  });
};

export default universalPreRecordedAudio;
